import { render, staticRenderFns } from "./FormEffectModal.vue?vue&type=template&id=73de6230&"
import script from "./FormEffectModal.vue?vue&type=script&lang=js&"
export * from "./FormEffectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports